import posthog from 'posthog-js';

import { PostHogEvent } from '@/core/analytics/posthog/utils/types';

export const captureEvent = (event: PostHogEvent) => {
  posthog.capture(
    event.name,
    'properties' in event ? event.properties : undefined,
  );
};
